<template>
  <div :style="alertStyle">
    <v-alert
      id="notification"
      v-bind="$attrs"
      v-model="alertValue"
      @click="$emit('updateAlert', alertValue)"
      :class="timeout && 'alert'"
    >
      {{ label }}
    </v-alert>
    <div
      id="notificationTimer"
      v-show="alert && timeout"
      class="notification-timer"
    />
  </div>
</template>

<script>
export default {
  name: "p-notification",

  data() {
    return {
      alertValue: this.alert,
      timeoutRef: null,
      originalTimeout: this.timeout,
      currentTimeout: 0,
      originalWidthTimer: 0,
      currentWidthTimer: 0,
    };
  },

  props: ["label", "alert", "timeout", "top", "bottom", "left", "right"],

  model: {
    prop: "alert",
    event: "updateAlert",
  },

  watch: {
    alert: {
      handler() {
        this.alertValue = this.alert;

        if (this.originalTimeout && this.alert) {
          this.currentTimeout = this.originalTimeout;
          this.setHoverEvents();
        }
      },
    },
  },

  mounted() {
    this.setHoverEvents();
  },

  computed: {
    alertStyle() {
      return {
        position: "absolute",
        top: `${this.top !== false && this.top}px !important`,
        bottom: `${this.bottom !== false && this.bottom}px !important`,
        left: `${this.left !== false && this.left}px !important`,
        right: `${this.right !== false && this.right}px !important`,
      };
    },
  },

  methods: {
    setAlertTimeout: function (time) {
      if (this.alert === true && this.originalTimeout) {
        let timeout = setTimeout(() => {
          let notificationTimer = document.getElementById("notificationTimer");
          let notification = document.getElementById("notification");

          notificationTimer.removeEventListener(
            "mouseenter",
            () => {
              notificationTimer.style.animationPlayState = "paused";

              clearTimeout(this.originalTimeoutRef);

              let pxPerMs = this.originalWidthTimer / this.originalTimeout;

              this.currentTimeout = this.currentWidthTimer / pxPerMs;
            },
            false
          );

          notificationTimer.removeEventListener(
            "mouseleave",
            () => {
              notificationTimer.style.animationPlayState = "";

              this.setAlertTimeout(this.currentTimeout);
            },
            false
          );

          notification.removeEventListener(
            "mouseenter",
            () => {
              notificationTimer.style.animationPlayState = "paused";

              clearTimeout(this.originalTimeoutRef);

              let pxPerMs = this.originalWidthTimer / this.originalTimeout;

              this.currentTimeout = this.currentWidthTimer / pxPerMs;
            },
            false
          );

          notification.removeEventListener(
            "mouseleave",
            () => {
              notificationTimer.style.animationPlayState = "";

              this.setAlertTimeout(this.currentTimeout);
            },
            false
          );

          this.currentTimeout = this.originalTimeout;
          this.currentWidthTimer = this.originalWidthTimer;
          this.$emit("updateAlert", false);
        }, time);

        this.originalTimeoutRef = timeout;
      }
    },

    setHoverEvents: function () {
      if (this.timeout) {
        this.setAlertTimeout(this.originalTimeout);

        let notificationTimer = document.getElementById("notificationTimer");
        let notification = document.getElementById("notification");

        notificationTimer.style.animation = `slider ${
          this.originalTimeout / 1000
        }s`;

        let resizeObserver = new ResizeObserver(() => {
          if (notificationTimer)
            this.currentWidthTimer = notificationTimer.offsetWidth;
        });

        if (notification && notificationTimer) {
          notification.addEventListener("mouseenter", () => {
            notificationTimer.style.animationPlayState = "paused";

            clearTimeout(this.originalTimeoutRef);

            let pxPerMs = this.originalWidthTimer / this.originalTimeout;

            this.currentTimeout = this.currentWidthTimer / pxPerMs;
          });

          notification.addEventListener("mouseleave", () => {
            notificationTimer.style.animationPlayState = "";

            this.setAlertTimeout(this.currentTimeout);
          });
        }

        if (notificationTimer) {
          if (!this.originalWidthTimer)
            this.originalWidthTimer = notificationTimer.offsetWidth;

          resizeObserver.observe(notificationTimer);

          notificationTimer.addEventListener("mouseenter", () => {
            notificationTimer.style.animationPlayState = "paused";

            clearTimeout(this.originalTimeoutRef);

            let pxPerMs = this.originalWidthTimer / this.originalTimeout;

            this.currentTimeout = this.currentWidthTimer / pxPerMs;
          });

          notificationTimer.addEventListener("mouseleave", () => {
            notificationTimer.style.animationPlayState = "";

            this.setAlertTimeout(this.currentTimeout);
          });
        }
      }
    },
  },
};
</script>

<style>
.v-alert__border {
  border-width: initial !important;
}

.alert {
  margin: 0 !important;
}

.notification-timer {
  border-bottom: 7px solid #b4eb98;
  border-radius: 4px;

  width: 100%;
  height: 500%;

  margin-top: -7px;

  position: sticky;
}

@keyframes slider {
  0% {
    width: 100%;
  }

  100% {
    width: 0%;
  }
}
</style>
